
<div v-if="filter">
    <v-row class="no-frame mt-3">
        <v-col class="no-frame mr-1 col-6 lm-border pa-3">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        :label  = "$t('contract.lim.title')"
                        v-model = "filter.lim"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        :label  = "$t('contract.dls.title')"
                        v-model = "filter.dls"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="no-frame lm-border pa-3 ml-1">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "aktiv"
                        v-model = "filter.active"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "inaktiv"
                        v-model = "filter.inactive"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</div>
